import * as React from "react";
import { iTableColumn, iTableRow } from "./interfaces";

export interface iProps {
  columns: iTableColumn[];
  rows: iTableRow[];
}

/**
 * Renders multiple rows for a table.
 */
const TableRows: React.SFC<iProps> = (props: iProps) => {
  /**
   * Extracts the final value for a single row cell.
   *
   * @param {iTableColumn} col
   * @param {iTableRow} row
   * @returns {React.ReactNode}
   */
  const renderCell = (
    col: iTableColumn,
    row: iTableRow,
    key: string,
  ): React.ReactNode => {
    if (col.render) {
      // Call the custom render function that should return a <td> element.
      // Clone it and override the "key" prop.
      const td = col.render(row, row[col.key]);
      return React.cloneElement(td, { key });
    }

    return (
      <td className="table__cell" key={key}>
        {row[col.key]}
      </td>
    );
  };

  // loops over each row and builds cells
  const rows: React.ReactNode[] = props.rows.map((row, index) => {
    const cols: React.ReactNode[] = props.columns.map((col) => {
      return renderCell(col, row, `row.${index}.${col.key}`);
    });

    return (
      <tr className="table__row" key={`row.${index}`}>
        {cols}
      </tr>
    );
  });

  return <tbody className="table__body">{rows}</tbody>;
};

export default TableRows;
